import { createFileRoute, redirect } from '@tanstack/react-router'

export const redirectLegacyDomainLaunch = ({ params }: { params: { orgId: number } }) => {
  throw redirect({
    to: '/$orgId/website/domains',
    params: { orgId: params.orgId },
    replace: true,
  })
}

export const Route = createFileRoute('/_authenticated/$orgId/website/domain-launch')({
  loader: redirectLegacyDomainLaunch,
})
